import { render, staticRenderFns } from "./changePwd.vue?vue&type=template&id=9b4213e2&"
import script from "./changePwd.vue?vue&type=script&lang=js&"
export * from "./changePwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\桌面\\学习资料\\ZXX\\ZJPMWEB\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b4213e2')) {
      api.createRecord('9b4213e2', component.options)
    } else {
      api.reload('9b4213e2', component.options)
    }
    module.hot.accept("./changePwd.vue?vue&type=template&id=9b4213e2&", function () {
      api.rerender('9b4213e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/changePwd.vue"
export default component.exports